import React from "react";
import RadialGauge from "./RadialGauge";
import { formatLocalDateTime } from "../../utils/dateTime";
import { formatLiveValue, isStringLiveValue, numericLiveValue } from "../../utils/tagValue";

const AnalogCard = ({ tag, latestMap, min = 0, max = 100, unit = "", title = "" }) => {
  const latest = latestMap?.[tag.name];

  const numeric = numericLiveValue(latest);
  const valueText = isStringLiveValue(latest) ? formatLiveValue(latest) : (numeric !== null ? numeric.toFixed(2) : "N/A");
  const ts = latest?.timestamp ?? "N/A";
  const gaugeVal = numeric !== null ? numeric : (min + max) / 2;

  return (
    <div className="dg-card">
      <div className="dg-card-head">
        <div className="dg-card-title">{title || tag.name}</div>
        <div className="dg-card-sub">ID: {tag.id}</div>
      </div>

      <RadialGauge
        value={gaugeVal}
        min={min}
        max={max}
        label={isStringLiveValue(latest) ? valueText : (numeric !== null ? `${valueText}${unit}` : "N/A")}
      />

      <div className="dg-row">
        <span className="dg-label">Value</span>
        <span className="dg-value-strong">
          {valueText}
          {isStringLiveValue(latest) || numeric === null ? "" : unit}
        </span>
      </div>
      {isStringLiveValue(latest) ? (
        <p className="dg-card-sub">String values are not plotted on this numeric gauge.</p>
      ) : null}

      <div className="dg-row">
        <span className="dg-label">Timestamp</span>
        <span className="dg-value-soft">{formatLocalDateTime(ts)}</span>
      </div>
    </div>
  );
};

export default AnalogCard;
